// Centralised DOMPurify wrapper. Used everywhere we render authored HTML
// via dangerouslySetInnerHTML — country data files, FAQ answers, etc.
// Content is developer-authored (not user input), but sanitizing is
// cheap defense-in-depth.
import DOMPurify from 'dompurify';

const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ['em', 'strong', 'br', 'span'],
  ALLOWED_ATTR: [],
};

export function safeHtml(text) {
  return { __html: DOMPurify.sanitize(text ?? '', SANITIZE_CONFIG) };
}

// Converts **bold** markdown to <strong>, then sanitizes.
export function boldMd(text) {
  const html = (text ?? '').replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  return { __html: DOMPurify.sanitize(html, SANITIZE_CONFIG) };
}
